export default __webpack_public_path__ + "static/media/preview-sms.55e4daaf.png";